import { whenNot } from 'platform/shared/health-apps';
import FinancialConfirmation from '../../../components/FormPages/FinancialConfirmation';
import { emptyObjectSchema } from '../../../definitions';
import {
  includeHouseholdInformation,
  includeSpousalInformation,
  spouseAddressDoesNotMatchVeterans,
  spouseDidNotCohabitateWithVeteran,
} from '../../../utils/helpers';
import { dependentsPages } from './dependents';
import dependentsOverview from './dependents/overview';
import financialDisclosure from './overview/financialDisclosure';
import financialOnboarding from './overview/financialOnboarding';
import financialsNeeded from './overview/financialsNeeded';
import spouseAdditionalInformation from './spouse/additionalInformation';
import spouseAnnualIncome from './spouse/annualIncome';
import spouseBasicInformation from './spouse/basicInformation';
import spouseContactInformation from './spouse/contactInformation';
import spouseFinancialSupport from './spouse/financialSupport';
import veteranAnnualIncome from './veteran/annualIncome';
import deductibleExpenses from './veteran/deductibleExpenses';
import maritalStatus from './veteran/maritalStatus';

export const householdPages = {
  maritalStatus: {
    path: 'household-information/marital-status',
    title: 'Marital status',
    ...maritalStatus,
  },
  financialOnboarding: {
    path: 'household-information/financial-information-use',
    title: 'Financial information use',
    ...financialOnboarding,
  },
  financialDisclosure: {
    path: 'household-information/share-financial-information',
    title: 'Share financial information',
    ...financialDisclosure,
  },
  financialConfirmation: {
    path: 'household-information/share-financial-information-confirm',
    title: 'Share financial information confirmation',
    depends: whenNot(includeHouseholdInformation),
    CustomPage: FinancialConfirmation,
    CustomPageReview: null,
    uiSchema: {},
    schema: emptyObjectSchema,
  },
  financialInformation: {
    path: 'household-information/financial-information-needed',
    title: 'Financial information needed',
    depends: includeHouseholdInformation,
    ...financialsNeeded,
  },
  spouseBasicInformation: {
    path: 'household-information/spouse-personal-information',
    title: 'Spouse’s personal information',
    depends: includeSpousalInformation,
    ...spouseBasicInformation,
  },
  spouseAdditionalInformation: {
    path: 'household-information/spouse-additional-information',
    title: 'Spouse’s additional information',
    depends: includeSpousalInformation,
    ...spouseAdditionalInformation,
  },
  spouseFinancialSupport: {
    path: 'household-information/spouse-financial-support',
    title: 'Spouse’s financial support',
    depends: spouseDidNotCohabitateWithVeteran,
    ...spouseFinancialSupport,
  },
  spouseContactInformation: {
    path: 'household-information/spouse-contact-information',
    title: 'Spouse’s address and phone number',
    depends: spouseAddressDoesNotMatchVeterans,
    ...spouseContactInformation,
  },
  dependentsOverview: {
    path: 'household-information/your-dependents',
    title: 'Your dependents',
    depends: includeHouseholdInformation,
    ...dependentsOverview,
  },
  ...dependentsPages,
  veteranAnnualIncome: {
    path: 'household-information/veteran-annual-income',
    title: 'Your annual income',
    depends: includeHouseholdInformation,
    ...veteranAnnualIncome,
  },
  spouseAnnualIncome: {
    path: 'household-information/spouse-annual-income',
    title: 'Spouse’s annual income',
    depends: includeSpousalInformation,
    ...spouseAnnualIncome,
  },
  deductibleExpenses: {
    path: 'household-information/deductible-expenses',
    title: 'Deductible expenses',
    depends: includeHouseholdInformation,
    ...deductibleExpenses,
  },
};
